import React, { useState, useRef, useEffect } from "react";
import { Button, Grid, TextField, CircularProgress } from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { ColDef } from "ag-grid-community";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { AgGridReact } from "ag-grid-react";

const MsisdnStatus = () => {
  const [msisdn, setMsisdn] = useState<string>("");
  const [isStatusDone, setIsStatusDone] = useState<boolean>(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [currentTable, setCurrentTable] = useState<string>("Table1");
  const [table1Data, setTable1Data] = useState<any[]>([]);
  const [table2Data, setTable2Data] = useState<any[]>([]);
  const [table3Data, setTable3Data] = useState<any[]>([]);
  const [table4Data, setTable4Data] = useState<any[]>([]);
  const [table5Data, setTable5Data] = useState<any[]>([]);
  const [table6Data, setTable6Data] = useState<any[]>([]);
  const [table7Data, setTable7Data] = useState<any[]>([]);
  const [table8Data, setTable8Data] = useState<any[]>([]);
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  const [showLimitedButtons, setShowLimitedButtons] = useState(false);
  const agGridRef = useRef<any>(null);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const parsedUser = JSON.parse(user);
      if (
        parsedUser.Email.includes("admin-support") ||
        parsedUser.Email === "muhammad.muzammil@now.net.pk" ||
        parsedUser.Email.includes("support")
      ) {
        setShowLimitedButtons(true);
      } else {
        setShowLimitedButtons(false);
      }
    }
  }, []);
  useEffect(() => {
    handleColumnSizing();
  }, [rowData, columnDefs]);

  const handlePaypalStatus = async () => {
    toast.dismiss();
    if (msisdn.trim().length > 9) {
      setRowData([]);
      setIsStatusDone(true);
      fetchData();
    } else {
      toast.error("Please enter valid Input.");
    }
  };

  const fetchData = async () => {
    setCurrentTable("");
    await axiosInterceptorInstance
      .get(`/dashboard/MsisdnStatus?Msisdn=${msisdn.trim()}`)
      .then((res: any) => {
        setIsStatusDone(false);
        const responseData = JSON.parse(res.data.body);

        if (responseData) {
          // Initialize all table data
          setTable1Data(responseData.Table1 || []);
          setTable2Data(responseData.Table2 || []);
          setTable3Data(responseData.Table3 || []);
          setTable4Data(responseData.Table4 || []);
          setTable5Data(responseData.Table5 || []);
          setTable6Data(responseData.Table6 || []);
          setTable7Data(responseData.Table7 || []);
          setTable8Data(responseData.Table8 || []);

          let tables = [
            { key: "Table1", data: responseData.Table1 },
            { key: "Table2", data: responseData.Table2 },
            { key: "Table3", data: responseData.Table3 },
            { key: "Table4", data: responseData.Table4 },
            { key: "Table5", data: responseData.Table5 },
            { key: "Table6", data: responseData.Table6 },
            { key: "Table7", data: responseData.Table7 },
            { key: "Table8", data: responseData.Table8 },
          ];

          if (showLimitedButtons) {
            tables = tables.filter(
              (table) => table.key === "Table4" || table.key === "Table6"
            );
          }

          const firstTableWithData = tables.find(
            (table) => table.data?.length > 0
          );

          if (firstTableWithData) {
            setCurrentTable(firstTableWithData.key);
            setRowData(firstTableWithData.data);
            setColumnDefs(getColumnDefs(firstTableWithData.key));
          } else {
            toast.info("No Record found Against this Msisdn");
          }
        } else {
          toast.info("No records found");
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
        setIsStatusDone(false);
      });
  };

  const getColumnDefs = (table: string): ColDef[] => {
    if (table === "Table1") {
      return [
        { field: "MSISDN", headerName: "Msisdn", resizable: true },
        { field: "OldMSISDN", headerName: "OldMsisdn", resizable: true },
        { field: "Email", headerName: "Email", resizable: true },
        { field: "OrderID", headerName: "OrderId", resizable: true },
        {
          field: "TransactionID",
          headerName: "TransactionId",
          resizable: true,
        },
        {
          field: "TransactionType",
          headerName: "TransactionType",
          resizable: true,
        },
        {
          field: "PaymentMethodType",
          headerName: "PaymentMethodType",
          resizable: true,
        },
        { field: "BundleName", headerName: "BundleName", resizable: true },
        { field: "IsAdyen", headerName: "IsAdyen", resizable: true },
        { field: "OrderStatus", headerName: "OrderStatus", resizable: true },
        { field: "ErrorMessage", headerName: "ErrorMessage", resizable: true },
        { field: "Amount", headerName: "Amount", resizable: true },
        { field: "Discount", headerName: "Discount", resizable: true },
        { field: "TotalAmount", headerName: "TotalAmount", resizable: true },
        {
          field: "OrderCreatedDate",
          headerName: "OrderCreatedDate",
          resizable: true,
        },
        {
          field: "OrderUpdatedTime",
          headerName: "OrderUpdatedTime",
          resizable: true,
        },
      ];
    } else if (table === "Table2") {
      return [
        { field: "first_name", headerName: "FirstName", resizable: true },
        { field: "last_name", headerName: "LastName", resizable: true },
        {
          field: "IsPaymentDone",
          headerName: "IsPaymentDone",
          resizable: true,
        },
        { field: "date_ordered", headerName: "OrderedDate", resizable: true },
        { field: "payment_date", headerName: "PaymentDate", resizable: true },
        {
          field: "CreditSimType",
          headerName: "CreditSimType",
          resizable: true,
        },
        { field: "isFulfilled", headerName: "IsFulfilled", resizable: true },
        {
          field: "fulfillment_date",
          headerName: "FulfillmentDate",
          resizable: true,
        },
        {
          field: "FulfilmentProcessed",
          headerName: "FulfillmentProcessed",
          resizable: true,
        },
      ];
    } else if (table === "Table3") {
      return [
        {
          field: "UserAccountID",
          headerName: "AccountID",
          resizable: true,
        },
        {
          field: "UserProductActiveStatus",
          headerName: "UserProductActiveStatus",
          resizable: true,
        },
        {
          field: "DefaultStatus",
          headerName: "DefaultStatus",
          resizable: true,
        },
        { field: "PortInDate", headerName: "PortInDate", resizable: true },
        {
          field: "DeletedStatus",
          headerName: "DeletedStatus",
          resizable: true,
        },
      ];
    } else if (table === "Table4") {
      return [
        {
          field: "PayPalProductRef",
          headerName: "Msisdn",
          resizable: true,
        },
        {
          field: "PayPalStatus",
          headerName: "PayPalStatus",
          resizable: true,
        },
        { field: "TotalCycles", headerName: "TotalCycles", resizable: true },
        {
          field: "RemainingCycles",
          headerName: "RemainingCycles",
          resizable: true,
        },
        {
          field: "NextBillingTime",
          headerName: "NextBillingTime",
          resizable: true,
        },
        {
          field: "LastBillingTime",
          headerName: "LastBillingTime",
          resizable: true,
        },
        {
          field: "CreatedTimeUtc",
          headerName: "CreatedTimeUtc",
          resizable: true,
        },
        {
          field: "UpdatedTimeUtc",
          headerName: "UpdatedTimeUtc",
          resizable: true,
        },
      ];
    } else if (table === "Table5") {
      return [
        {
          field: "AcAccount",
          headerName: "Account",
          resizable: true,
        },
        {
          field: "adt_date",
          headerName: "AuditDate",
          resizable: true,
        },
        {
          field: "method",
          headerName: "Type",
          resizable: true,
        },
        { field: "reason", headerName: "Reason", resizable: true },
      ];
    } else if (table === "Table6") {
      return [
        {
          field: "NowMobileCustomerAccount",
          headerName: "NowMobileCustomerAccount",
          resizable: true,
        },
        {
          field: "SimActivationDate",
          headerName: "SimActivationDate",
          resizable: true,
        },
        {
          field: "SimStatus",
          headerName: "SimStatus",
          resizable: true,
        },
      ];
    } else if (table === "Table7") {
      return [
        {
          field: "account",
          headerName: "Account",
          resizable: true,
        },
        {
          field: "isAvailable",
          headerName: "IsAvailable",
          resizable: true,
        },
        {
          field: "isActive",
          headerName: "IsActive",
          resizable: true,
        },
        {
          field: "activation_Date",
          headerName: "ActivationDate",
          resizable: true,
        },
        {
          field: "isFulfilled",
          headerName: "IsFulfilled",
          resizable: true,
        },
        {
          field: "fulfillmentDateTime",
          headerName: "FulfillmentDateTime",
          resizable: true,
        },
        {
          field: "fulfillmentErrorMessage",
          headerName: "FulfillmentErrorMessage",
          resizable: true,
        },
        {
          field: "modified_date",
          headerName: "ModifiedDate",
          resizable: true,
        },
      ];
    } else if (table === "Table8") {
      return [
        {
          field: "calling_package_id",
          headerName: "BundleId",
          resizable: true,
        },
        {
          field: "RenewalStauts",
          headerName: "RenewalStatus",
          resizable: true,
        },
        {
          field: "created_date",
          headerName: "CreatedDate",
          resizable: true,
        },
        {
          field: "last_execution_date",
          headerName: "LastExecutionDate",
          resizable: true,
        },
        {
          field: "SuccessStatus",
          headerName: "SuccessStatus",
          resizable: true,
        },
        {
          field: "ErrorMessage",
          headerName: "ErrorMessage",
          resizable: true,
        },
        {
          field: "RetryCount",
          headerName: "RetryCount",
          resizable: true,
        },
        {
          field: "NumberOfRenewalsCompleted",
          headerName: "RenewalsCompleted",
          resizable: true,
        },
        {
          field: "payment_method",
          headerName: "PaymentMethod",
          resizable: true,
        },
        {
          field: "ActiveStatus",
          headerName: "ActiveStatus",
          resizable: true,
        },
        {
          field: "card_pan_masked",
          headerName: "CardLast4Digit",
          resizable: true,
        },
        {
          field: "PaymentGateway",
          headerName: "PaymentGateway",
          resizable: true,
        },
      ];
    }
    return [];
  };

  const handleTableSwitch = (table: string) => {
    toast.dismiss();
    if (table === "Table1") {
      if (table1Data?.length === 0) {
        toast.info("No records found in OrderDetail Table");
      } else {
        setCurrentTable("Table1");
        setRowData(table1Data);
        setColumnDefs(getColumnDefs("Table1"));
      }
    } else if (table === "Table2") {
      if (table2Data?.length === 0) {
        toast.info("No records found in CreditSim Detail Table");
      } else {
        setCurrentTable("Table2");
        setRowData(table2Data);
        setColumnDefs(getColumnDefs("Table2"));
      }
    } else if (table === "Table3") {
      if (table3Data?.length === 0) {
        toast.info("No records found in AccountDetail Table");
      } else {
        setCurrentTable("Table3");
        setRowData(table3Data);
        setColumnDefs(getColumnDefs("Table3"));
      }
    } else if (table === "Table4") {
      if (table4Data?.length === 0) {
        toast.info("No records found in PayPalStatus Table");
      } else {
        setCurrentTable("Table4");
        setRowData(table4Data);
        setColumnDefs(getColumnDefs("Table4"));
      }
    } else if (table === "Table5") {
      if (table5Data?.length === 0) {
        toast.info("No records found in TransactionsDetail Table");
      } else {
        setCurrentTable("Table5");
        setRowData(table5Data);
        setColumnDefs(getColumnDefs("Table5"));
      }
    } else if (table === "Table6") {
      if (table6Data?.length === 0) {
        toast.info("No records found in SimStatus Table");
      } else {
        setCurrentTable("Table6");
        setRowData(table6Data);
        setColumnDefs(getColumnDefs("Table6"));
      }
    } else if (table === "Table7") {
      if (table7Data?.length === 0) {
        toast.info("No records found in SimPool Table");
      } else {
        setCurrentTable("Table7");
        setRowData(table7Data);
        setColumnDefs(getColumnDefs("Table7"));
      }
    } else if (table === "Table8") {
      if (table8Data?.length === 0) {
        toast.info("No records found in AutoRenewal History Table");
      } else {
        setCurrentTable("Table8");
        setRowData(table8Data);
        setColumnDefs(getColumnDefs("Table8"));
      }
    }
  };
  const onGridReady = (params: { api: any }) => {
    agGridRef.current = params.api;
    handleColumnSizing();
  };

  const handleColumnSizing = () => {
    if (agGridRef.current && columnDefs.length < 6) {
      agGridRef.current.sizeColumnsToFit();
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Msisdn Status</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="Msisdn"
                variant="outlined"
                defaultValue={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4}>
              <Button
                onClick={() => handlePaypalStatus()}
                className="dButton dButton2"
                variant="contained"
                disabled={isStatusDone}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          {isStatusDone && (
            <div className="circular-loader" style={{ marginLeft: "0px" }}>
              <CircularProgress size={40} />
            </div>
          )}
        </div>
      </div>
      {rowData.length > 0 && (
        <>
          <div className="multipleTables">
            {showLimitedButtons ? (
              <>
                <Button
                  variant={currentTable === "Table4" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table4")}
                >
                  PayPal Status
                </Button>
                <Button
                  variant={currentTable === "Table6" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table6")}
                >
                  Sim Status
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant={currentTable === "Table1" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table1")}
                >
                  Order Detail
                </Button>
                <Button
                  variant={currentTable === "Table2" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table2")}
                >
                  CreditSim Detail
                </Button>
                <Button
                  variant={currentTable === "Table3" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table3")}
                >
                  Account Detail
                </Button>
                <Button
                  variant={currentTable === "Table4" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table4")}
                >
                  PayPal Status
                </Button>
                <Button
                  variant={currentTable === "Table5" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table5")}
                >
                  Transactions Detail
                </Button>
                <Button
                  variant={currentTable === "Table6" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table6")}
                >
                  Sim Status
                </Button>
                <Button
                  variant={currentTable === "Table7" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table7")}
                >
                  Sim Pool
                </Button>
                <Button
                  variant={currentTable === "Table8" ? "contained" : "outlined"}
                  onClick={() => handleTableSwitch("Table8")}
                >
                  AutoRenewal History
                </Button>
              </>
            )}
          </div>
          <div className="ag-theme-alpine">
            <AgGridReact
              paginationPageSize={12}
              pagination={true}
              domLayout="autoHeight"
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              enableCellTextSelection={true}
            ></AgGridReact>
          </div>
        </>
      )}
    </motion.div>
  );
};

export default MsisdnStatus;
